import React, { useState, useEffect } from 'react';
import Navbar from '../MainComponents/Navbar';
import './Home.css';
import { FaChevronRight, FaLocationDot, FaArrowRight } from "react-icons/fa6";
import InfoBox from './InfoBox';
import { FaPizzaSlice, FaTruck } from "react-icons/fa";
import { FaMoneyBills } from "react-icons/fa6";
import { GiKnifeFork } from "react-icons/gi";
import { BiSolidSushi } from "react-icons/bi";
import { FaBurger } from "react-icons/fa6";
import { MdRamenDining } from "react-icons/md";
import { IoLeaf } from "react-icons/io5";
import { BiSolidCoffeeBean } from "react-icons/bi";
import { GiCupcake } from "react-icons/gi";
import { FaCheckCircle, FaStar, FaCheck } from "react-icons/fa";
import comercial from "../../Assets/commercial.jpg";
import { Link, useNavigate } from 'react-router-dom';
import Card from './Card';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from '../../Firebaseconfig';
import Footer from '../MainComponents/Footer';
import driverImage from "../../Assets/nshpejt-delivery.png";
import { useTranslation } from 'react-i18next';







function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' open' : ''}`} onClick={() => setOpen(o => !o)}>
      <div className="faq-question">
        <span>{question}</span>
        <FaChevronRight className={`faq-chevron${open ? ' rotated' : ''}`} />
      </div>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

function Home() {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [homeSearch, setHomeSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    // Fetch products — slice to 3 on client side to avoid index requirement
    const q = query(collection(db, 'products'));
    const unsubProducts = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => {
            const aTime = a.createdAt?.seconds ?? 0;
            const bTime = b.createdAt?.seconds ?? 0;
            return bTime - aTime;
          })
          .slice(0, 3);
        setProducts(data);
        setLoading(false);
      },
      (error) => {
        console.error('Firestore error in Home:', error);
        setLoading(false);
      }
    );
    return () => unsubProducts();
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05,
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-stagger'
    );
    revealElements.forEach((el) => observer.observe(el));

    return () => {
      revealElements.forEach((el) => observer.unobserve(el));
    };
  }, [loading, products]);


  return (
    <div>
      <Navbar />

      <div className={`hero ${isLoaded ? 'animate-in' : ''}`}>
        <h1>{t('home.heroTitleLine1')}<br />{t('home.heroTitleLine2')}<br />{t('home.heroTitleLine3')}</h1>
        <p>{t('home.heroSubtitle')}</p>

        <div className="searchbar">
          <FaLocationDot />
          <input 
            type="text" 
            placeholder={t('home.searchPlaceholder')} 
            value={homeSearch}
            onChange={(e) => setHomeSearch(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/products?search=${encodeURIComponent(homeSearch)}`); }}
          />
          <button onClick={() => navigate(`/products?search=${encodeURIComponent(homeSearch)}`)}>{t('home.findFood')} <FaArrowRight /></button>
        </div>
      </div>

      <div className="why-us">
        <h2 className="reveal">{t('home.whyUsTitle')}</h2>
        <p className="reveal">{t('home.whyUsSubtitle')}</p>
        
        <div className="boxes reveal-stagger">
            <InfoBox 
              title={t('home.curatedChoices')} 
              description={t('home.curatedChoicesDesc')} 
              icon={<GiKnifeFork />} 
            />

            <InfoBox 
              title={t('home.seamlessCheckout')} 
              description={t('home.seamlessCheckoutDesc')} 
              icon={<FaMoneyBills />} 
            />

            <InfoBox 
              title={t('home.whiteGloveDelivery')} 
              description={t('home.whiteGloveDeliveryDesc')} 
              icon={<FaTruck />} 
            />
          
        </div>
      </div>

      <div className="categories">
        <div className="text reveal">
          <div className="left">
            <h2>{t('home.exploreCategories')}</h2>
          <p>{t('home.satisfyCraving')}</p>
          </div>
        </div>

        <div className="category-box reveal-stagger">
          <InfoBox 
            icon={<FaPizzaSlice />}
            title={t('home.catPizza')}
            onClick={() => navigate('/products?category=Pizza')}
          />
          <InfoBox
            icon={<BiSolidSushi />}
            title={t('home.catSushi')}
            onClick={() => navigate('/products?category=Sushi')}
          />
          <InfoBox
            icon={<FaBurger />}
            title={t('home.catBurgers')}
            onClick={() => navigate('/products?category=Burgers')}
          />
          <InfoBox
            icon={<MdRamenDining />}
            title={t('home.catAsian')}
            onClick={() => navigate('/products?category=Asian')}
          />
          <InfoBox
            icon={<IoLeaf />}
            title={t('home.catHealthy')}
            onClick={() => navigate('/products?category=Healthy')}
          />
          <InfoBox
            icon={<GiCupcake />}
            title={t('home.catDesserts')}
            onClick={() => navigate('/products?category=Desserts')}
          />
          <InfoBox
            icon={<BiSolidCoffeeBean />}
            title={t('home.catCoffee')}
            onClick={() => navigate('/products?category=Coffee')}
          />
        </div>
      </div>

      <div className="experience">
        <div className="experience-left reveal-left">
          <div className="premium-badge">
            <FaStar className="star-icon" />
            <span>{t('home.premiumSelection')}</span>
          </div>
          <h2>{t('home.culinaryExcellence')}<br />{t('home.delivered')}</h2>
          <p>
            {t('home.chefsChoiceDesc')}
          </p>
          <div className="experience-checks">
            <div className="check-item">
              <span className="check-icon-wrapper"><FaCheck /></span>
              <span>{t('home.check1')}</span>
            </div>
            <div className="check-item">
              <span className="check-icon-wrapper"><FaCheck /></span>
              <span>{t('home.check2')}</span>
            </div>
            <div className="check-item">
              <span className="check-icon-wrapper"><FaCheck /></span>
              <span>{t('home.check3')}</span>
            </div>
          </div>
          <button className="premium-btn">{t('home.explorePremium')}</button>
        </div>

        <div className="experience-right reveal-right">
          <div className="partner-card" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0) 40%, rgba(0,0,0,0.95) 100%), url(${comercial})` }}>
            <div className="partner-content">
              <span className="partner-label">{t('home.featuredPartner')}</span>
              <h3 className="partner-title">N11</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="trending-section reveal">
        <div className="trending-header">
          <h2 className="trending-title">
            {t('home.trendingNearYou')}
          </h2>
          <Link to="/products" className="trending-see-all">
            {t('home.seeAll')} <FaChevronRight />
          </Link>
        </div>

        {loading ? (
          <div className="trending-loading">
            <div>{t('home.loadingProducts')}</div>
          </div>
        ) : products.length === 0 ? (
          <div className="trending-empty">
            <div>{t('home.noProductsYet')}</div>
          </div>
        ) : (
          <div className="trending-grid reveal-stagger">
            {products.map(product => (
              <Card
                key={product.id}
                product={product}
              />
            ))}
          </div>
        )}
      </div>

      {/* ── Farm Fresh Section ── */}
      <div className="farm-fresh">
        <div className="farm-fresh-left reveal-left">
          <div className="farm-badge">
            <span className="farm-badge-dot" />
            {t('home.farmFreshBadge')}
          </div>
          <h2>{t('home.farmFreshTitleLine1')}<br />{t('home.farmFreshTitleLine2')}</h2>
          <p>{t('home.farmFreshDesc')}</p>
          <div className="farm-grid">
            <div className="farm-item">
              <IoLeaf className="farm-icon" />
              <span>{t('home.organicProducts')}</span>
            </div>
            <div className="farm-item">
              <GiCupcake className="farm-icon" />
              <span>{t('home.freshBakery')}</span>
            </div>
            <div className="farm-item">
              <BiSolidCoffeeBean className="farm-icon" />
              <span>{t('home.wineSpirits')}</span>
            </div>
            <div className="farm-item">
              <FaMoneyBills className="farm-icon" />
              <span>{t('home.pharmacyEssentials')}</span>
            </div>
          </div>
          <button className="farm-btn">{t('home.shopGroceries')}</button>
        </div>
        <div className="farm-right reveal-right" />
      </div>

      {/* ── Driver CTA Section ── */}
      <div className="driver-cta">
        <div className="driver-cta-inner">
          {/* Left — image placeholder */}
          <div className="driver-image-col reveal-left">
            <div className="driver-image-placeholder" >
              <img className="driver-img" src={driverImage} alt="driver" />
            </div>
          </div>

          {/* Right — text, stats, button */}
          <div className="driver-content-col reveal-right">
            <div className="driver-text">
              <h2>{t('home.driveSuccessTitle')}</h2>
              <p>{t('home.driveSuccessDesc')}</p>
            </div>
            <div className="driver-stats">
              <div className="stat-item">
                <span className="stat-value">5K+</span>
                <span className="stat-label">{t('home.partnerRestaurants')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">1M+</span>
                <span className="stat-label">{t('home.happyCustomers')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">$25/hr</span>
                <span className="stat-label">{t('home.avgEarnings')}</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">100%</span>
                <span className="stat-label">{t('home.tipsKept')}</span>
              </div>
            </div>
            <Link to="/signup" className="driver-btn">{t('home.applyToRide')}</Link>
          </div>
        </div>
      </div>

      {/* ── CraveDash Standard Section ── */}
      <div className="standards">
        <h2 className="reveal">{t('home.craveDashStandard')}</h2>
        <div className="standards-grid reveal-stagger">
          <div className="standard-item">
            <div className="standard-icon teal"><GiKnifeFork /></div>
            <div>
              <h4>{t('home.stdCuratedSelection')}</h4>
              <p>{t('home.stdCuratedDesc')}</p>
            </div>
          </div>
          <div className="standard-item">
            <div className="standard-icon orange"><FaCheck /></div>
            <div>
              <h4>{t('home.stdQualityGuarantee')}</h4>
              <p>{t('home.stdQualityDesc')}</p>
            </div>
          </div>
          <div className="standard-item">
            <div className="standard-icon teal"><FaTruck /></div>
            <div>
              <h4>{t('home.std247Support')}</h4>
              <p>{t('home.stdSupportDesc')}</p>
            </div>
          </div>
          <div className="standard-item">
            <div className="standard-icon orange"><FaMoneyBills /></div>
            <div>
              <h4>{t('home.stdWhiteGlove')}</h4>
              <p>{t('home.stdWhiteGloveDesc')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* ── FAQ Section ── */}
      <div className="faq-section">
        <h2 className="reveal">{t('home.commonQuestions')}</h2>
        <div className="faq-list reveal-stagger">
          {[
            { q: t('home.faq1Q'), a: t('home.faq1A') },
            { q: t('home.faq2Q'), a: t('home.faq2A') },
            { q: t('home.faq3Q'), a: t('home.faq3A') },
          ].map(({ q, a }, i) => (
            <FaqItem key={i} question={q} answer={a} />
          ))}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Home